import React from 'react';
import {BuyButton} from './BuyButton';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ReserveButton} from './ReserveButton';
import {SubscribeButton} from './SubscribeButton';
import styles from './style.module.scss';
import cs from 'classnames';

type TActionsProps = Pick<IProductSnippet, 'availability' | 'cart' | 'url'>;

export const CartActions = (props: TActionsProps) => {
    const {
        cart: {
            onReserve,
            onSubscribe,
            onAddOne,
            onRemoveOne,
            onQuantityChange,
            onGoToCart,
            isPendingQuantityChange,
            quantity,
        },
        availability,
        url,
    } = props;

    return (
        <div data-skeleton-item={true} className={cs(styles.root, {[styles[availability]]: availability})}>
            {
                {
                    ['IN_STOCK']: (
                        <BuyButton
                            onAddOne={onAddOne}
                            onRemoveOne={onRemoveOne}
                            isPendingQuantityChange={isPendingQuantityChange}
                            onQuantityChange={onQuantityChange}
                            onGoToCart={onGoToCart}
                            quantity={quantity}
                        />
                    ),
                    ['FOR_RESERVATION']: <ReserveButton onReserve={onReserve} url={url} />,
                    ['OUT_OF_STOCK']: <SubscribeButton onSubscribe={onSubscribe} url={url} />,
                }[availability]
            }
        </div>
    );
};
